import { AuthProvider } from './AuthProvider';
import { AuthSessionSync } from './AuthSessionSync';
import { StoreProvider } from './StoreProvider';

export function AppProviders({ children }) {
  return (
    <AuthProvider>
      <StoreProvider>
        <AuthSessionSync />
        {children}
      </StoreProvider>
    </AuthProvider>
  );
}
